import { Injectable } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { LoadingState } from '@lcs/shared/api';
import { combineLatest, fromEvent, merge, Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { LcsSingleSelectInputService } from '../../single-select/single-select-input.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { CollectionCallState } from './collection-call-state';

@Injectable({ providedIn: 'root' })
export class EagerSelectStatusService {
   constructor(private singleSelectInputService: LcsSingleSelectInputService) {}

   initialize(
      formField: MatFormField,
      trigger: LcsSingleSelectDirective<any>,
      element: HTMLInputElement,
      loadResultState$: Observable<CollectionCallState>,
      load: () => void,
      search: (searchTerm: string | null | undefined) => void,
      searchReset: () => void
   ): Observable<never> {
      const loading = combineLatest([loadResultState$, trigger.overlayAttached]).pipe(
         tap(([state, overlayAttached]: [CollectionCallState, boolean]) => {
            if (state.callState === LoadingState.Loading) {
               if (overlayAttached) {
                  formField.hintLabel = 'Loading...';
               } else {
                  formField.hintLabel = '';
               }
               trigger.stateChanges.next();
            } else if (state.callState === LoadingState.Loaded) {
               if (state.totalCount === 0) {
                  formField.hintLabel = 'No results found.';
               } else {
                  formField.hintLabel = '';
               }
               trigger.stateChanges.next();
            } else if (state.callState !== LoadingState.Init) {
               formField.hintLabel = 'An error has occurred. Please try again.';
               trigger.stateChanges.next();
            }
         })
      ) as Observable<never>;

      const focus = fromEvent<never>(element, 'focus').pipe(
         filter(() => {
            return !trigger.panelOpen;
         }),
         tap(() => {
            load();
         })
      );

      const { blur, closed, input } = this.singleSelectInputService.getObservables(
         trigger,
         element,
         search,
         searchReset
      );

      return merge(focus, input, blur, closed, loading);
   }
}
